import React, { FunctionComponent } from 'react';
import { IntlProvider } from 'react-intl';
import { Box } from '@mui/material';
import { useLocale } from '../../contexts/LocaleProvider';
import BrowseAllProductHome from './BrowseAllProductHome';
import { useLocation } from 'react-router-dom';
import { useProductGroups } from '../../graphql/pimcore/modules/resourceLibrary/contexts/ProductGroupsProvider';
import LoadingOverlay from '../common/LoadingOverlay';
import { useProductsContent } from '../../graphql/pimcore/modules/siteContent/hooks/useProductsContent';

const BrowseAllProductPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();
    const location = useLocation();
    const { productGroupByDmDefinitionId, productGroupById, loading } = useProductGroups();
    const { loading: productContentLoading, contentTree } = useProductsContent();

    return (
        <>
            <LoadingOverlay loading={loading || productContentLoading} />
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <Box
                    width="100%"
                    component="main"
                    sx={{
                        padding: 0,
                        flexGrow: 0,
                        p: 0,
                    }}
                >
                    <BrowseAllProductHome
                        queryRawResults={location.state?.queryRawResults}
                        searchInput={location.state?.searchInput}
                        customBannerMessage={location.state?.customBannerMessage}
                        includeResourceLibrary={location.state?.includeResourceLibrary}
                        excludeProducts={location.state?.excludeProducts}
                        shouldClearAllProps={location.state?.shouldClearAllProps}
                        productGroupByDmDefinitionId={productGroupByDmDefinitionId}
                        productGroupById={productGroupById}
                        contentTree={contentTree}
                    />
                </Box>
            </IntlProvider>
        </>
    );
};

export default BrowseAllProductPage;
